module.exports = __webpack_public_path__ + "img/clkb.5caf63db.png";